import React from 'react';
import styled from 'styled-components';

const BarraCargando = ({ size }: { size?: string }) => {
    return (
        <StyledWrapper size={size}>
            <svg viewBox="25 25 50 50">
                <circle r={20} cy={50} cx={50} />
            </svg>
        </StyledWrapper>
    );
}

const StyledWrapper = styled.div<{ size?: string }>`
    display: inline-block;
    vertical-align: middle;

    svg {
        width: ${props => props.size || '1.5em'};
        height: ${props => props.size || '1.5em'};
        transform-origin: center;
        animation: rotate4 2s linear infinite;
    }

    circle {
        fill: none;
        stroke: hsl(214, 97%, 59%);
        stroke-width: 4;
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
        stroke-linecap: round;
        animation: dash4 1.5s ease-in-out infinite;
    }

    @keyframes rotate4 {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes dash4 {
        0% {
            stroke-dasharray: 1, 200;
            stroke-dashoffset: 0;
        }

        50% {
            stroke-dasharray: 90, 200;
            stroke-dashoffset: -35px;
        }

        100% {
            stroke-dashoffset: -125px;
        }
    }`;

export default BarraCargando;
